module.exports = __webpack_public_path__ + "img/quick-start.412f105d.jpg";